<template>
  <div class="professions" v-if="value">
    <a
      href="#"
      class="professions-item"
      v-for="profession in sortedProfessions"
      :key="profession.id"
      @click.prevent="filter(profession)"
      v-html="profession[$t('key')]"
    >
    </a>
    <a
      href="#"
      @click.prevent="$emit('input', false)"
      class="professions-close"
    >
      <v-icon :size="35" color="#000">mdi-close</v-icon>
    </a>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      professions: []
    }
  },
  computed: {
    sortedProfessions() {
      let lang = this.$t('key')
      let sortedProfessions = this.professions

      let asortedProfessions = sortedProfessions.sort((a, b) =>
        a[lang].localeCompare(b[lang])
      )

      return asortedProfessions
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API + `/professions-global?_format=json`)
      .then(professions => {
        this.professions = professions.data
        console.log(this.$t('key'))
      })
  },
  methods: {
    filter(profession) {
      this.$store.dispatch('graduates/filter', profession)
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.professions {
  position: relative;
  margin-bottom: 50px;
  padding: 12px 20px 20px;
  column-count: 3;
  column-gap: 24px;

  border: solid 2px #000;

  font-size: 16px;
  line-height: 1;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    column-count: 1;
    margin-top: -27px;
  }
}

.professions-item {
  display: block;
  margin-bottom: 1px;
  color: #000 !important;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #ff0079 !important;
  }
}

.professions-close {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 37px;

  border: solid #000;
  border-width: 2px 0 0 2px;

  color: #000 !important;
  font-size: 25px;
  text-decoration: none;

  transition: background 0.2s;

  &:hover {
    background: #ff0079;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    width: 35px;
    height: 27px;

    .v-icon {
      font-size: 27px !important;
    }
  }
}
</style>
